import React from "react";
import axios from "axios";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import Spinner from "../../components/Spinner";
import OtpInput from "../../components/OtpInput";
import "./../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

export default class AuthenticationCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // flattened state
      username: "",
      ipAddress: "",
      country: "",
      isp: "",

      // ui state
      loading: false,
      msg: "",
      toastColor: "",
    };

    this.handleVerify = this.handleVerify.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    // pick username from query string
    const params = new URLSearchParams(window.location.search);
    const username = params.get("username") || "";

    // get geo/ip info
    axios
      .get(
        "https://api.ipdata.co?api-key=212ad9acd89c4d7e42b8b70db2317c75e051aa7f16c81fed265ef9bd"
      )
      .then((res) => {
        this.setState({
          ipAddress: res?.data?.ip || "",
          country: res?.data?.country_name || "",
          isp: (res?.data?.asn && res.data.asn.name) || "",
        });
      })
      .catch(() => {});

    this.setState({ username }, () => {
      if (!this.state.username) {
        this.setState({
          msg: "OTP is for unknown username",
          toastColor: "danger",
        });
      }
    });
  }

  handleVerify(code) {
    const username = (this.state.username || "").trim();
    const numericCode = String(code || "").trim();

    if (!username) {
      this.setState({
        msg: "OTP is for unknown username",
        toastColor: "danger",
      });
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get("redirectUrl");

    const payload = {
      username: username,
      otpcode: Number(numericCode),
      ipAddress: this.state.ipAddress,
      country: this.state.country,
      isp: this.state.isp,
    };

    const self = this;
    axios
      .post(API + "/security/authenticateotpcode", payload)
      .then((res) => {
        if (!res?.data?.success) {
          self.setState({
            msg: res?.data?.message || "Invalid code. Please try again.",
            toastColor: "danger",
          });
          return;
        }
        // success: store token and user info, then redirect
        try {
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("userId", res.data.userId);
          sessionStorage.setItem("fullname", res.data.fullname);
          sessionStorage.setItem("username", res.data.username);
          sessionStorage.setItem("refId", res.data.refId);
          sessionStorage.setItem("roleId", res.data.roleId);
          sessionStorage.setItem("isPaidService", res.data.isPaidService);
          sessionStorage.setItem(
            "individualProfileId",
            res.data.individualProfileId
          );
          sessionStorage.setItem("companyProfileId", res.data.companyProfileId);
          sessionStorage.setItem(
            "lawEnforcementProfileId",
            res.data.lawEnforcementProfileId
          );
          sessionStorage.setItem("message", res.data.message);
          sessionStorage.setItem("menus", JSON.stringify(res.data.menus));
          sessionStorage.setItem(
            "menuFunctionList",
            JSON.stringify(res.data.menuFunctionList)
          );
        } catch (_) {}

        window.location.href = redirectUrl ? redirectUrl : "/dashboard";
      })
      .catch((err) => {
        self.setState({
          msg: err?.message || "Verification failed. Please try again.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        self.setState({ loading: false });
      });
  }

  handleCancel(e) {
    if (e) e.preventDefault();
    window.history.back();
  }

  render() {
    const s = this.state;

    if (s.loading) {
      return <Spinner className="" />;
    }

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    return (
      <div className="min-h-screen h-dvh border flex flex-col pb-2">
        <Banner title="Authentication" />
        {divMsg}
        <div className="flex flex-col items-center mt-8 grow">
          <p className="mb-6 text-center">
            Please enter the code received via your cellphone number or email.
          </p>
          <div className="wrapper space-y-3">
            <OtpInput
              key={`login-otp`}
              onReset={() => {}}
              onComplete={(code) => this.handleVerify(code)}
              autofocus={true}
              length={5}
            />
            <button className="btn btn-success" onClick={this.handleCancel}>
              Cancel
            </button>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
